module.exports = __webpack_public_path__ + "static/media/UN-10.bc6d45f3.jpg";